export default __webpack_public_path__ + "static/media/SB-BIOLOGY-HIGH-SCHOOL-AP-U2.1f53e2ad.jpg";